module.exports = __webpack_public_path__ + "img/venus-mars.f93cb772.svg";